<template>
    <div>
        <Breadcrumbs main="Customers" title="Customer List"/>
        <!-- Container-fluid starts-->
        <div class="container-fluid">
            <div class="row">

              <div class="col-md-12">
                <div class="card">
                    <div hidden class="card-header">
                      <h5>Zero Configuration</h5>
                      <span>DataTables has most features enabled by default, so all you need to do to use it with your own tables is to call the construction function:<code>$().DataTable();</code>.</span><span>Searching, ordering and paging goodness will be immediately added to the table, as shown in this example.</span>
                    </div>

                    <div class="card-body">
                      <b-row>
                          <b-col md="4">

                              <b-input-group label-cols="" class="datatable-">
                                  <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
                                  <b-input-group-append>
                                      <b-button id="default-secondary" variant="secondary" :disabled="!filter" @click="filter = ''">Clear</b-button>
                                  </b-input-group-append>
                              </b-input-group>

                          </b-col>

                          <!-- <b-col md="3">
                            <b-form-group hidden label-cols="4" content-cols="6"  label="Selection" class="mb-0 datatable-select">
                                <b-form-select
                                  id="table-select-mode-select"
                                  v-model="selectMode"
                                  :options="modes"
                                  class="mb-3"
                                ></b-form-select>
                              </b-form-group>
                          </b-col> -->

                          <b-col md="4">
                              <b-form-group label-cols="4" content-cols="4" label="Per page" class="mb-0 datatable-select">
                                  <b-form-select style="width:100px" v-model="perPage" :options="pageOptions"></b-form-select>
                              </b-form-group>
                              
                          </b-col>

                          <b-col md="4">
                            <div class="text-right">
                              <div class="form-group mb-0 mr-0"></div>
                              <a  class="btn btn-outline-primary mb-2 mr-3 " v-b-modal.smsModal >
                                <i class="icon-message"> </i> SMS </a
                              >
                              <a class="btn btn-primary mr-3 mb-2" v-b-modal.groupModal >
                                
                                <i class="icon-shopping-car"> </i> Groups</a
                              >
                              <!-- <a hidden class="btn btn-outline-primary mr-3 mb-2" v-b-modal.request >
                                
                                <i class="icon-user"> </i> Patient Request</a
                              >
                              <a  class="btn btn-outline-primary mr-3 " v-b-modal.importPatient >
                                <i class="icon-cloud-up"> </i> Import </a
                              > -->
                              <a  class="btn btn-outline-primary mr-2 mb-2" v-b-modal.addGroupModal v-if="selected.length > 0">
                               Group ({{ selected.length }}) </a
                              >
                              <a v-if="selected.length > 0" @click="clearSelected()" class="btn btn-danger mb-2"><i class="icon-close"> </i> </a
                              >
                              <!-- <b-form-group  label-cols="4" content-cols="4" :label="`Apply to (${selected.length})`" class="mb-0 datatable-select">
                                  <b-form-select @input="applyTo" style="width:100px" v-model="select" :options="selectOptions"></b-form-select>
                              </b-form-group> -->
                            </div>

                          </b-col>
                      </b-row>

                      <b-modal id="shopModal" size="lg" ref="shopModal" :title="'View Shop Profiles : '+shopTitle" ok-title="Ok" class="theme-modal">
                              <b-table
                                show-empty
                                ref="shopTable"
                                :items="allShops"
                                :fields="shopfields"
                                :per-page="perShopPage"
                              >
                                  <template #cell(shop)="row">
                                    <span style="font-weight:500;" class="txt-primary">
                                      {{ row.item.shop }}
                                    </span>
                                </template>
                                
                                <template #cell(user)="row">

                                  <a style="font-weight:500" :href="`tel:${row.item.user.countryCode+row.item.user.tel}`" class="txt-primary">
                                      {{ row.item.user.countryCode+row.item.user.tel }}
                                    </a>
                                </template>

                                <template #cell(preferences)="row">

                                    <div class="btn btn-primary btn-xs btn-pill mr-2 mb-2" v-for="pref in row.item.preferences" :key="pref">
                                        {{ pref }}
                                    </div>

                                </template>

                                <template #cell(createdAt)="row">
                                      {{ new Date(row.item.createdAt).toDateString().substr(4) }}
                                </template>

                              </b-table>
                            </b-modal>


                            <b-modal id="addGroupModal" size="md" ref="addGroupModal" :title="`Group (${selected.length}) Customers`" ok-title="Done" class="theme-modal">

                                <form id="groupForm" @submit.stop.prevent="groupCustomers" class="p-2 px-3">

                                  <div class="form-group ">
                                    <label class="col-form-label" type="text" for="recipient-name">Select Group:</label>
                                    <!-- <b-form-input v-model="group.group" placeholder="Group"></b-form-input> -->
                                    <b-form-select required v-model="select" :options="allGroups"></b-form-select>
                                  </div>
                                  <div class="form-group ">
                                  <label class="col-form-label" type="text" for="recipient-name">Selected Customers:</label>
                                    <div class="form-group mt-2">  

                                        <div class="btn btn-primary btn-xs btn-pill mr-2 mb-2" v-for="cus in selected" :key="cus._id">
                                                {{ cus.name }} 
                                                <!-- - {{ cus.phone.countryCode+cus.phone.tel }} -->
                                        </div>

                                    </div>
                                  </div>
                                    <b-button block  type="submit" variant="primary">Submit</b-button>

                                </form>
                              </b-modal>



                              <b-modal id="smsModal" size="lg" ref="smsModal" title="Send SMS" ok-title="Done" class="theme-modal">
                                <template #modal-header>
                                    <h5>Send SMS <span v-if="numbers > 0" class="txt-primary">({{ numbers }})</span> </h5>
                                    
                                </template>

                                <form id="smsForm" @submit.stop.prevent="submitSms" class="p-2 px-3">

                                  <div class="row ">
                                    <div class="col-6 ">
                                      <label class="col-form-label" type="text" for="recipient-name">Select Groups: </label>
                                      <!-- <b-form-input v-model="group.group" placeholder="Group"></b-form-input> -->
                                      <v-select :disabled="smsGroupDisabled" multiple v-model="sms.groups" placeholder="Groups" :options="allGroups.map(ob =>ob.text)" label="All Groups" @input="checkGroups"></v-select>
                                    </div>
                                    <div class="col-6 ">
                                      <label class="col-form-label" type="text" for="recipient-name">Select Contacts: 
                                        <!-- <span @click="selectAllContacts" class="btn btn-xs btn-primary"> select all </span> -->
                                      </label>
                                      <v-select :disabled="smsContactsDisabled" multiple v-model="sms.contacts" :options="items.map((it)=> {
                                          return { label:it.name, value: it.phone }
                                        })" placeholder="Contacts / Leave blank for all contacts" @input="checkContact"></v-select>
                                    </div>
                                    
                                    <!-- <b-form-select multiple v-model="sms.groups" :options="allGroups"></b-form-select> -->
                                  </div>
                                  <div class="row form-group mt-2">
                                    <div class="col-6 ">
                                      <label class="col-form-label" type="text" for="recipient-name">Schedule :</label>
                                      <b-form-input type="date" v-model="sms.date" placeholder="Schedule Date"></b-form-input>
                                    </div>
                                    <div class="col-6 ">
                                      <label class="col-form-label" type="text" for="recipient-name">Time </label>
                                      <b-form-input type="time" v-model="sms.time" placeholder="Schedule TIme"></b-form-input>
                                    </div>
                                  </div>
                                  <div class="form-group mt-2">  
                                    <label class="col-form-label" for="">Message: <span class="txt-primary">( {{ sms.message.length }}/800 Characters )</span></label>
                                    <b-form-textarea
                                        id="textarea"
                                        v-model="sms.message"
                                        placeholder="Enter Message ..."
                                        rows="5"
                                        @input="mesLength"
                                        :state="sms.message.length <= 800 && sms.message.length > 0"
                                        
                                        length="800"
                                    ></b-form-textarea>
                                    <label class="mt-2"><b> Sms Parts :</b> <span class="txt-primary "> {{ smsParts }}/5</span> SMS <b>Cost: </b>  <span class="txt-primary ">{{ smsParts*numbers }} SMSes</span></label>
                                    <label ><b>NB:</b> To send personalised messages, use <span class="txt-primary ">@fullname</span> for fullname, <span class="txt-primary ">@fisrtname</span> for firstname <span class="txt-primary ">@lastname</span> for lastname</label>
                                  </div>
                                    <b-button block :disabled="submitting" type="submit" variant="primary"> {{ submitting ? 'Submitting, please wait!' : 'Submit' }} </b-button>

                                </form>
                                <div class="px-3 py-2">
                                    <b-table
                                        show-empty
                                        ref="groupTable"
                                        :items="allSms"
                                        :fields="smsfields"
                                        :sort-by.sync="sortSmsBy"
                                        :current-page="currentSmsPage"
                                        :per-page="perSmsPage"

                                    >
                                        <template #cell(group)="row">
                                            <span @click="view(row.item)" style="font-weight:500;" class="txt-primary">
                                              {{ row.item.group }} 
                                            </span>
                                            <br>
                                            <span v-b-tooltip.hover title="Description" > {{ row.item.description }} </span>
                                            <i style="font-size:0.8rem;color:;" v-if="userAdmin"><br> - {{ row.item.shop }}  </i>
                                        </template>

                                        <template #cell(createdAt)="row">
                                              {{ row.item.createdAt ? new Date(row.item.createdAt).toDateString().substr(4) : '' }}
                                        </template>

                                        <template #cell(tels)="row">
                                              {{ row.item.tels.join(", ") }}
                                        </template>

                                        <template #cell(message)="row">
                                          
                                          {{ row.item.message }}
                                          <!-- <div :class="`btn ${row.item.type=='Instant' ? 'btn-info' : 'btn-secondary'} btn-xs btn-pill mr-2 mb-2`" >
                                                    {{ row.item.type == "Instant" ? row.item.type : row.item.type+" : "+new Date(row.item.scheduled).toString().substr(4,20) }}
                                            </div> -->
                                        </template>

                                        

                                        <template #cell(groups)="row">

                                          <div class="btn btn-primary btn-xs btn-pill mr-2 mb-2" v-for="group in row.item.groups" :key="group">
                                                  {{ group }}

                                                  
                                          </div>
                                          <span v-if="userAdmin">{{ row.item.shop }}</span>
                                        </template>

                                        <template #cell(details)="row">

                                          <span>Contacts:{{ row.item.tels.length }}</span><br>
                                          <span>Message:{{ row.item.message.replace(/(\r\n|\n|\r)/gm, " ").length }}</span><br>
                                          <!-- <span>Parts: {{ Math.ceil(row.item.message.replace(/(\r\n|\n|\r)/gm, " ").length/160)  }}</span><br> -->
                                          <span>Sent:{{ row.item.status ? (Math.ceil(row.item.message.replace(/(\r\n|\n|\r)/gm, " ").length/160) * row.item.tels.length) : 0 }}</span><br>
                                          <div :class="`btn ${row.item.status ? 'btn-primary' : 'btn-warning txt-dark'} btn-xs btn-pill mr-2 mb-2`">
                                                  {{ row.item.status ? 'Sent' : 'Not sent' }}
                                          </div>

                                        </template>

                                        <template #cell(type)="row">

                                            <div :class="`btn ${row.item.type=='Instant' ? 'btn-info' : 'btn-secondary'} btn-xs btn-pill mr-2 mb-2`" >
                                                    {{ row.item.type == "Instant" ? row.item.type : row.item.type+" : "+new Date(row.item.scheduled).toString().substr(4,20) }}
                                            </div>

                                        </template>
                                        

                                        <template #cell(action)="row">

                                        <!-- <b-button variant="primary" @click="editgroup(row.item)" class="px-3 mr-2" size="sm"> <i class="icon-pencil"> </i>  </b-button> -->
                                        <b-button variant="danger" @click="delSms(row.item)" class="px-3" size="sm"> <i class="icon-trash"> </i> </b-button>

                                        </template>
                                    </b-table>
                                    <p class="px-3">{{ allSms.length }} items </p>

                                    <b-col md="6" class="my-1">
                                        <b-pagination
                                        v-model="currentSmsPage"
                                        :total-rows="totalSmsRows"
                                        :per-page="perSmsPage"
                                        class="my-0"
                                        ></b-pagination>
                                    </b-col>
                                </div>
                            </b-modal>


                      <b-modal id="groupModal" size="md" ref="groupModal" title="Add Groups" ok-title="Done" class="theme-modal">
                                <template #modal-header>
                                    <h5>{{ editGroup ? 'Edit Groups : '+editGroup : 'Add Groups' }} </h5>
                                    
                                </template>

                                <form id="groupForm" @submit.stop.prevent="submitGroup" class="p-2 px-3">

                                  <div class="form-group ">
                                    <label class="col-form-label" type="text" for="recipient-name">Group name:</label>
                                    <b-form-input v-model="group.group" placeholder="Group"></b-form-input>
                                  </div>
                                  <div class="form-group mt-2">  
                                    <label class="col-form-label" for="">Description</label>
                                    <b-form-textarea
                                        id="textarea"
                                        v-model="group.description"
                                        placeholder="Enter Description..."
                                        rows="3"
                                        max-rows="6"
                                    ></b-form-textarea>
                                  </div>
                                    <b-button block  type="submit" variant="primary">Submit</b-button>

                                </form>
                                <div class="px-3 py-2">
                                    <b-table
                                        show-empty
                                        ref="groupTable"
                                        :items="allGroups"
                                        :fields="groupfields"
                                        :sort-by.sync="sortGroupBy"
                                        :current-page="currentGroupPage"
                                        :per-page="perGroupPage"
                                    >
                                        <template #cell(group)="row">
                                            <span @click="view(row.item)" style="font-weight:500;" class="txt-primary">
                                              {{ row.item.group }} 
                                            </span>
                                            <br>
                                            <span v-b-tooltip.hover title="Description" > {{ row.item.description }} </span>
                                            <i style="font-size:0.8rem;color:;" v-if="userAdmin"><br> - {{ row.item.shop }}  </i>
                                        </template>

                                        <template #cell(createdAt)="row">
                                              {{ row.item.createdAt ? new Date(row.item.createdAt).toDateString().substr(4) : '' }}
                                        </template>
                                        

                                        <template #cell(action)="row">

                                        <b-button variant="primary" @click="editgroup(row.item)" class="px-3 mr-2" size="sm"> <i class="icon-pencil"> </i>  </b-button>
                                        <b-button variant="danger" @click="delgroup(row.item)" class="px-3" size="sm"> <i class="icon-trash"> </i> </b-button>

                                        </template>
                                    </b-table>
                                    <p class="px-3">{{ allGroups.length }} items </p>

                                    <b-col md="6" class="my-1">
                                        <b-pagination
                                        v-model="currentGroupPage"
                                        :total-rows="totalGroupRows"
                                        :per-page="perGroupPage"
                                        class="my-0"
                                        ></b-pagination>
                                    </b-col>
                                </div>
                            </b-modal>

                      <div class="table-responsive datatable-vue">
                        <b-table
                          show-empty
                          ref="selectableTable"
                          selectable
                          :items="items"
                          :fields="tablefields"
                          :select-mode="selectMode"
                          :sort-by.sync="sortBy"
                          :sort-desc.sync="sortDesc"
                          :filter="filter"
                          :current-page="currentPage"
                          :per-page="perPage"
                          @filtered="onFiltered"
                          @row-selected="onRowSelected"
                        >
                          <template #cell(action)="row">
                            <!-- <b-button size="sm" @click="row.toggleDetails" class="mr-2 ">
                              {{ row.detailsShowing ? 'Hide' : 'Show'}} Details
                            </b-button> -->
                            <b-dropdown text="more" size="sm" left class="mx-2" menu-class="dropdown-content" variant="primary">
                              <b-dropdown-item @click="shops(row.item)">Shop Profiles</b-dropdown-item>
                              <b-dropdown-item @click="alert(row.item)">Alert</b-dropdown-item>
                              <b-dropdown-item @click="Sms(row.item)">SMS</b-dropdown-item>
                              <b-dropdown-item @click="clear(row.item)">Clear Groups</b-dropdown-item>
                              <!-- <b-dropdown-item @click="view(row.item)">View </b-dropdown-item> -->
                              <!-- <b-dropdown-item v-if="row.item.access[0].status" @click="addcomment(row.item)">Add comment</b-dropdown-item> -->
                              <!-- <b-dropdown-item v-if="row.item.access[0].status" @click="viewcomment(row.item.fullname, row.item.tel)">View comment</b-dropdown-item> -->
                              <!-- <b-dropdown-divider></b-dropdown-divider> -->
                              <!-- <b-dropdown-item @click="del(row.index)">Delete </b-dropdown-item> -->
                          </b-dropdown>
                          </template>
        

                          <template #cell(active)="row">
                            <!-- <a :class="`btn ${ row.item.status (row.item.status == 'active' ? 'btn-primary' : 'btn-warning text-dark')} btn-xs btn-pill mr-3`" @click="status(row.item.status)">
                                
                              {{ row.item.status }}  </a @click="status(row.item.access[0])"
                              > -->
                              <div v-b-tooltip.hover @click="status(row.item)" title="Click to change status" :class="`btn ${ (row.item.active ? 'btn-primary' : 'btn-warning text-dark')} btn-xs btn-pill mr-3`">
                                {{ (row.item.active ? 'Active' : 'Inactive') }}
                              </div>
                          </template>

                          <template #cell(gender)="row">
                            <div class="btn btn-info btn-xs btn-pill mr-3">
                                {{ row.item.gender }}
                            </div>
                        </template>
                    

                          <template #cell(dob)="row">
                            <span v-if="row.item.dob" v-b-tooltip.hover class="txt-primary" :title="`${calculateAge(row.item.dob)} years`"> {{  new Date(row.item.dob).toDateString().substr(4) }} </span>
                          </template>

                          <template #cell(email)="row">

                              <a style="font-weight:500" :href="`mailto:${row.item.email}`" class="txt-primary">
                                {{ row.item.email }}
                             </a>
                          </template>

                          <template #cell(phone)="row">

                            <a style="font-weight:500" :href="`tel:${row.item.phone.countryCode+row.item.phone.tel}`" class="txt-primary">
                                {{ row.item.phone.countryCode+row.item.phone.tel }}
                              </a>
                          </template>

                          <template #cell(point)="row">

                            <span style="font-weight:500" class="txt-primary">
                                <!-- {{ row.item.points.length > 0 ? parseFloat(row.item.points.reduce((a, b) => a + b.point, 0) ) : 0  }} -->

                                {{ row.item.point  }}

                            </span>
                          </template>

                          <template #cell(groups)="row">

                              <div  v-if="row.item.groups"> 

                                <div class="btn btn-primary btn-xs btn-pill mr-2 mb-2" v-for="(gp, index) in row.item.groups.filter(g=> userAdmin ? g.shop !== '' : g.shop == getUser.name)" :key="gp+index">
                                        {{ gp.group }}
                                </div>

                              </div>

                            </template>

                          <template #cell(date)="row">
                                <!-- {{ row.item.createdAt ? new Date(row.item.createdAt).toDateString().substr(4) : '' }} -->
                                {{ row.item.date }}
                          </template>
                        </b-table>
                        
                      </div>

                      <p>{{ totalRows.length }} items </p>

                      <b-col md="6" class="my-1">
                        <b-pagination
                          v-model="currentPage"
                          :total-rows="totalRows"
                          :per-page="perPage"
                          class="my-0"
                        ></b-pagination>
                      </b-col>
                      


                    </div>

                </div>
              </div>

            </div>
        </div>
        <!-- Container-fluid Ends-->
    </div>
</template>

<script>
// import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import axios from 'axios'
// import Multiselect from 'vue-multiselect'
import moment from 'moment'

export default {
  data(){
    return{
      singledropzoneOptions:{
          url:"http://localhost:8080/uploadpatient",
          thumbnailWidth: 150,
          maxFiles:1,
          maxFilesize: 0.7,
          addRemoveLinks: true,
          dictDefaultMessage:"<i class='icon-cloud-up'></i><h6>Drop file here or click to upload.</h6><span>( Selected file is <strong>uploaded</strong> imediately after selection.)</span>"
      },
      requestLoading: false,
      submitting: false,
      categorySelect: true,
      typeSelect: true,
      codeData: {},
      shopTitle: '',
      editGroup: false,
      group: {
        group: '',
        description: ''
      },
      sms: {
        contacts: [],
        groups: [],
        date: '',
        time: '',
        message: ''
      },
      smsParts: 0,
      smsMsg: 0,
      numbers: 0,
      smsGroupDisabled: false,
      smsContactsDisabled: false,
      statusOptions: [
        //   { value: null, text: 'Select ' },
        { value: true, item: 'Yes' },
        { value: false, item: 'No' }
      ],
      tablefields: [
        { key: 'name', label: 'Customer Name', sortable: true, },
        { key: 'phone', label: 'Contact', sortable: false, },
        { key: 'email', label: 'Email', sortable: true, },
        { key: 'gender', label: 'Gender', sortable: true, },
        { key: 'groups', label: 'Groups', sortable: true, },
        { key: 'dob', label: 'Date of Birth', sortable: true, },
        // { key: 'locationName', label: 'Location', sortable: true, },
        { key: 'point', label: 'Points', sortable: true, },
        // { key: 'active', label: 'Status', sortable: true, },
        { key: 'date', label: 'Date', sortable: true, },
        { key: 'action', label: 'Action', sortable: false, },
      ],
      shopfields: [
        { key: 'shop', label: 'Shop', sortable: true, },
        { key: 'preferences', label: 'Preferences', sortable: false, },
        { key: 'createdAt', label: 'Date', sortable: false, },
        { key: 'action', label: 'Action', sortable: false, },
      ],
      items: [],
      allShops: [],
      allGroups: [],
      allSms: [],
      modes: ['multi', 'single', 'range'],
      filter: null,
      sortBy: 'createdAt',
      sortDesc: true,
      selectMode: 'multi',
      selected: [],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [5, 10, 15, 25, 50, 100],
      groupfields: [
        { key: 'group', label: 'Group', sortable: true, },
        // { key: 'type', label: 'Type', sortable: true, },
        // { key: 'description', label: 'Description', sortable: false, },
        { key: 'createdAt', label: 'Date', sortable: true, },
        { key: 'action', label: 'Action', sortable: false, },
      ],
      smsfields: [
        // { key: 'sender', label: 'sender', sortable: true, },
        { key: 'groups', label: 'Groups', sortable: true, },
        { key: 'tels', label: 'Contacts', sortable: true, },
        // { key: 'contacts', label: 'Contacts', sortable: true, },
        { key: 'message', label: 'Message', sortable: false, },
        { key: 'details', label: 'Details', sortable: false, },
        { key: 'type', label: 'Type', sortable: true, },
        // { key: 'description', label: 'Description', sortable: false, },
        { key: 'date', label: 'Date', sortable: true, },
        { key: 'action', label: 'Action', sortable: false, },
      ],
      sortGroupBy: 'product',
      currentGroupPage: 1,
      totalGroupRows: 1,
      sortSmsBy: 'date',
      currentSmsPage: 1,
      totalSmsRows: 1,
      perGroupPage: 5,
      perSmsPage: 5,
      totalShopRows: 1,
      perShopPage: 5,
      selectOptions: [
        'Group',
      ],
      select: null,
    }
  },
  components: {
    
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.tablefields
        .filter(f => f.sortable)
        .map(f => {
          return { text: f.label, value: f.key }
        })
    },
    userAdmin() {
      return localStorage.getItem('type') == "admin" ? true : false
    },
    getUser() {
      return this.$store.getters['authentication/getUser']
    }
  },
  created() {
    // watch and fetch
    this.$watch(
      () => this.$route.$params,
      () => {
        this.fetchData()
      },
      { immediate: true }

    )

  },
  watch: {
    dropFile() {
        if (this.dropFile !== null ){
            this.img = window.URL.createObjectURL(this.dropFile)    
        }

        if (this.dropFile == null) {
            window.URL.revokeObjectURL(this.img)
        }
    },
    productFile() {
        if (this.productFile !== null ){
            this.pro = window.URL.createObjectURL(this.productFile)    
        }

        if (this.productFile == null) {
            window.URL.revokeObjectURL(this.pro)
        }
    },
  },
  mounted() {
    // Set the initial number of items
    // this.totalRows = this.items.length
  },
  methods: {
    fetchData() {

     const url = this.userAdmin ? '/users/' : '/users/'+this.getUser.name

      axios.get(url)
        .then(response=>{
          //
          this.items = response.data
          this.totalRows = this.items.length

          for (let index = 0; index < this.items.length; index++) {

                // date
                if (this.items[index].createdAt) {
                  this.items[index].date = this.userAdmin ? (new Date(this.items[index].createdAt)).toDateString().substring(4) : (new Date(this.items[index].shops.find(s=>s.shop == this.getUser.name).createdAt)).toDateString().substring(4)
                  // this.items[index].date = (new Date(this.items[index].createdAt)).toDateString().substring(4)
                
                }

                this.items[index].label = this.items[index].name

                this.items[index].gp = this.items[index].groups.map(g=>g.group);

                // this.items[index].point = this.items[index].points.length > 0 ? parseFloat(this.items[index].points.reduce((a, b) => a + b.point, 0) ) : 0

                this.items[index].point = this.items[index].points.length > 0 ? this.userAdmin ? parseFloat(this.items[index].points.reduce((a, b) => a + b.point, 0) ) : parseFloat(this.items[index].points.filter(s=>s.shop == this.getUser.name).reduce((a, b) => a + b.point, 0) ) : 0
            }
        })
        .catch( e => {
          this.$swal({
            title:"Failed!",
            text:e.response.data,
            type:'error'
          });
        })

        const ln = this.userAdmin ? '/groups/' : '/groups/'+this.getUser.name

        axios.get(ln).then( response=>{

            //
            this.allGroups = response.data
            this.totalGroupRows = response.data.length

            for (let index = 0; index < this.allGroups.length; index++) {

                // date
                if (this.allGroups[index]) {
                  this.allGroups[index].text = this.allGroups[index].group
                  this.allGroups[index].value = this.allGroups[index].group
                }
            }

        }).catch(error=>{

            console.log(error.response.data)
        })


        const ln2 = this.userAdmin ? '/shop/sms/' : '/shop/sms?shop='+this.getUser.name

        axios.get(ln2).then( response=>{

            //
            this.allSms = response.data
            this.totalSmsRows = response.data.length

            for (let index = 0; index < this.allSms.length; index++) {
                //

                // date
                if (this.allSms[index]) {
                  this.allSms[index].date = (new Date(this.allSms[index].createdAt)).toDateString().substring(4)
                  this.allSms[index].tels = this.allSms[index].contacts.map(c=> c.phone.countryCode+c.phone.tel)
                }
            }

        }).catch(error=>{

            console.log(error.response.data)
        })

        // axios.get('/vendor')
        // .then(response=>{
        //   //
        //   //   this.items = response.data
        //   const vendors = response.data.map(vendor => vendor.business)
        //   this.vendorOptions = []
        //   //   this.vendorOptions  = [...new Set(vendors)]
        // //   const vendorList = []
          
        //   for (let index = 0; index < vendors.length; index++) {
        //     const value = { code: vendors[index], name: vendors[index] };
        //     this.vendorOptions.push(value)
        //   }
        //   console.log(this.vendorOptions)
          
        // })
        // .catch( e => {
        //   this.$swal({
        //     title:"Failed!",
        //     text:e.response.data,
        //     type:'error'
        //   });
        // })
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    onRowSelected(items) {
      this.selected = items
    },
    selectAllRows() {
      this.$refs.selectableTable.selectAllRows()
    },
    clearSelected() {
      this.$refs.selectableTable.clearSelected()
    },
    shops(data) {
        // modal
        this.$refs.shopModal.show()
        //
        this.shopTitle = data.name

        //
        // axios.get('/order/'+data.business).then( response=>{
            let _shop = this.getUser.name

            //
            this.allShops = this.userAdmin ? data.shops : data.shops.filter(shop => shop.shop == _shop)
            this.totalShopRows= this.userAdmin ? data.shops.length : data.shops.filter(shop => shop.shop == _shop).length

        // }).catch(error=>{

        //     console.log(error.response.data)
        // })

    },
    groupCustomers() {
      
      axios.post('/group/customers', { shop: this.getUser.name, group: this.select, customers: this.selected }).then(response=> {

            this.$swal({
          title:"Good job!",
          text: response.data,
          type:'success'
        });

        this.fetchData()
        //
        
      })
      .catch( e => {
        this.$swal({
          title:"Failed!",
          text: e.response.data,
          type:'error'
        });
      })

    },
    submitGroup() {

      let url
      let method

      if (this.editGroup) {
        url = '/group/'+this.editGroup
        method = axios.patch;
      } else {
        url = '/group/'
        method = axios.post;
      }

      method(url, { shop: this.getUser.name, group: this.group.group, description: this.group.description } )
      .then(response=>{
        //
        this.$swal({
          title:"Good job!",
          text: response.data,
          type:'success'
        });

        this.fetchData()
        //
        
        
      })
      .catch( e => {
        this.$swal({
          title:"Failed!",
          text: e.response.data,
          type:'error'
        });
      })

    },
    submitSms() {

      this.submitting = true

      //
      let contacts;
      if (this.sms.groups.length > 0) {
        contacts = this.items.filter(d => d.gp.some(x => this.sms.groups.includes(x)) ).map(c=>{ return { phone: c.phone, name:c.name } })
      } else if (this.sms.contacts.length > 0) {
        contacts = this.sms.contacts.map(c=>{ return { phone: c.value, name: c.label } })
      } else if (this.sms.contacts.length == 0) {
        contacts = this.items.map(c=>{ return { phone: c.phone, name: c.name } })
      }

      if (contacts.length > 0 && this.sms.message !== "") {

        axios.post('/shop/sms/', { shop: this.getUser.name, message: this.sms.message, contacts: contacts, groups:  this.sms.groups, scheduled: (this.sms.date !== '' && this.sms.time !== '' ? this.sms.date+' '+this.sms.time : null) } )
        .then(response=>{
          //
          this.$swal({
            title:"Good job!",
            text: response.data,
            type:'success'
          });

          this.fetchData()
          //
          this.submitting = false
          
        })
        .catch( e => {
          this.$swal({
            title:"Failed!",
            text: e.response.data,
            type:'error'
          });

          this.submitting = false
        })
      } else {
        this.submitting = false
      }
    },
    view(data){
      // modal
      this.$refs.viewvendorModal.show()

      this.viewVendor = data
      //
    },
    Sms(data){
      // modal
      this.$refs.smsModal.show()

      this.sms.contacts = [ { label: data.name, value: data.phone } ]
      this.checkContact()
      this.sms.groups = []
      this.checkGroups()
      //
    },
    checkGroups(){
      if (this.sms.groups.length > 0) {
        this.smsContactsDisabled = true
        const no = this.items.filter(d => d.gp.some(x => this.sms.groups.includes(x)) )
        this.numbers = no.length
      } else {
        this.smsContactsDisabled = false
        this.numbers = 0 
      }
    },
    checkContact(){
      if (this.sms.contacts.length > 0) {
        this.smsGroupDisabled = true
        this.numbers = this.sms.contacts.length
      } else {
        this.smsGroupDisabled = false
        this.numbers = 0
      }
    },
    switchCategory() {
        this.categorySelect = this.categorySelect ? false : true
    },
    switchType() {
        this.typeSelect = this.typeSelect ? false : true
    },
    applyTo() {
        //
        this.$refs.groupModal.show()
    },
    calculateAge(dob) { 
      //
      let now
      now = moment(new Date())
      const _dob = moment(dob)
      return now.diff(_dob, 'years')
    },
    mesLength() {
      const smslen = 160;
      // const maxlen = 800;
      // const maxparts = 5;

      var strlen = this.sms.message.length;
      // var msg = strlen+'/'+maxlen;

      this.smsParts = Math.ceil(strlen/smslen);
      // var msg2 = parts+'/'+maxparts;
    },
    delSms(data) {
      //
      axios.delete(`/shop/sms/${data.shop}/${data._id}`)
      .then(response=>{
        //
        this.$swal({
          title:"Good job!",
          text: response.data,
          type:'success'
        });
        //
        this.fetchData()
      })
      .catch( e => {
        this.$swal({
          title:"Failed!",
          text: e.response.data,
          type:'error'
        });
      })

    },
    selectAllContacts() {
      this.sms.contacts = this.items.map((it)=> {
                                          return { label:it.name, value: it.phone }
                                        })
    }
  }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped>
/* #patientForm .form-control {
 font-size: inherit;
} */

.table tr > td {
  color: rgba(43,43,43,.54);
}

.loader-box [class*="loader-"] {
    width: 30px;
    height: 30px;
}
</style>